// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_8BM","cls2":"Cta-cls2_qWG Cta-cls1_8BM"};